import translation from 'locales/translation';
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, TextField } from '@material-ui/core';
import GenericModal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';

import api from 'api/Assessor/duvidas';
import { assembleiasAssessorActionsLoadDuvidas } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';

import ErrorHandler from 'helpers/utils/ErrorHandler';
import { TextRange } from 'helpers/utils/StringUtils';

import useStyle from './style';

interface IncluirMensagemModalProps extends IGenericModalProps {
  key: string;
  idEvento: number;
}

interface Props extends IModalProps {
  genericProps: IncluirMensagemModalProps;
}

const LIMIT_MESSAGE = 500;

export default function IncluirMensagemModal({ genericProps, open }: Props) {
  const dispatch = useDispatch();
  const classes = useStyle();
  const [value, setValue] = useState<string>('');
  const [isSending, setSending] = useState<boolean>(false);

  const handleClose = useCallback((): void => {
    if (genericProps?.key) {
      dispatch(modalsActionsClose(genericProps.key));
    }
  }, [genericProps, dispatch]);

  const canSubmit = useMemo(() => {
    return value.trim().length > 0;
  }, [value]);

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (!canSubmit) return;
      setSending(true);
      const { fail, data } = await api.mensagem({
        idEvento: genericProps.idEvento,
        duvida: value,
      });
      setSending(false);
      if (fail) {
        ErrorHandler(fail);
      }
      if (data) {
        dispatch(assembleiasAssessorActionsLoadDuvidas(genericProps.idEvento));
        handleClose();
      }
    },
    [canSubmit, value, genericProps, handleClose, dispatch]
  );

  return (
    <GenericModal
      open={open ?? false}
      title={translation.AssessorMensagens.send.title}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
      }}
      content={
        <form className={classes.modalContent} onSubmit={handleSubmit}>
          <TextField
            label={translation.AssessorMensagens.send.inputLabel}
            onChange={(event) => {
              event.target.value = TextRange(event.target.value, LIMIT_MESSAGE);
              setValue(event.target.value);
            }}
            multiline
            inputProps={{
              maxLength: LIMIT_MESSAGE,
            }}
            helperText={`${value.length}/${LIMIT_MESSAGE}`}
            required
          />
          <footer className={classes.modalFooter}>
            <Button
              type='button'
              variant='outlined'
              color='primary'
              onClick={handleClose}
              disabled={isSending}
            >
              {translation.AssessorMensagens.send.cancel}
            </Button>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              disabled={!canSubmit || isSending}
            >
              {translation.AssessorMensagens.send.done}
            </Button>
          </footer>
        </form>
      }
    />
  );
}
